import { isObjectWithId } from "@/types/apiStore";

export function getObjectId(
  id: number | Object | undefined | null,
): number | null {
  if (typeof id === "number") {
    return id;
  }
  if (isObjectWithId(id)) {
    return getObjectId(id?.id);
  }
  return null;
}
